import Request from '@request/Request';
import CustomSightingsRequest from '@request/CustomSightingsRequest';
import Model from '@models/CustomGroup';

export default class extends CustomSightingsRequest {
  constructor(validationObserver, data = {}) {
    data = {
      ...Model.data(),
      ...data,
    };
    super(validationObserver, data);
    this.model = new Model();
  }

  async submit() {
    this.beforeSubmit();
    try {
      let response = await this.model.checkoutCustomTrip(this.data());
      $showSuccess(response.message, 'group-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }

  async submitBulk() {
    this.beforeSubmit();
    try {
      let response = await this.model.checkoutBulkCustomTrip(
        this.data().payload
      );
      $showSuccess(response.message, 'group-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }

  async getBulkCheckoutAmount() {
    try {
      return await this.model.getBulkCheckoutAmount(this.data().payload);
    } catch (error) {
      this.handleError(error);
    }
  }
}
